module.exports = __webpack_public_path__ + "img/2f_r_fukumitsu@2x.ba22cfea.jpg";